<template>
  <a @click="cancel" class="closeButton">
    <i class="fas fa-times"></i>
  </a>
</template>

<script>
export default {
  methods: {
    cancel() {
      document.body.classList.add("cancel");
    }
  }
};
</script>
